import { Updatable } from '../../..';

export default class NMISettings extends Updatable {
    public privateKey: string;
    public publicKey: string;
    public webhookKey: string;

    constructor(settings?: Partial<NMISettings>) {
        super();
        if (settings) this.update(settings);
    }

    update(entity: Partial<NMISettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }

    toJson() {
        return {
            ...this
        }
    }
}